module.exports = __webpack_public_path__ + "img/chevrolet.4b86b4b6.png";